import {all } from "redux-saga/effects";

import { axios } from "lib/axios";
import {HTTP_TIMEOUT, URL_AUTHENTICATION_LOGOUT, URL_AUTHENTICATION_VALIDATE} from "../constants/Urls";
import {baseUrl} from "../util/keys";
import { userManager } from "lib/auth.config";
import { isSuperAdmin } from "features/auth/helpers";

export const validateUser = async () => {
  const authenticatedUser = await userManager.getUser();
  return await axios
    .get(`${baseUrl}${URL_AUTHENTICATION_VALIDATE}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Accept-Language": "en-US",
        Authorization: `Bearer ${authenticatedUser?.access_token}`,
      },
      withCredentials: true,
      timeout: HTTP_TIMEOUT,
    })
    .then((response) => {
      if (response.status !== 200 || !response.data.user) {
        return response;
      }
      const preferredClient = response.data.user.current_client_info;
      const user = {
        id: response.data.user.id,
        first_name: response.data.user.first_name,
        last_name: response.data.user.last_name,
        email: response.data.user.email,
        language: response.data.user.user_settings.language_code,
        user_name: response.data.user.username,
        client_id: [],
        preferred_font: response.data.user.user_settings.preferred_font,
        currentRoleModules: response.data.user.current_role_modules,
        role: response.data.user.role,
        culture_id: 0,
        preferred_client: preferredClient,
        timezone: response.data.user.user_settings.timezone,
        theme_colour: response.data.user.user_settings.theme_colour,
      };
      return {
        ...response,
        data: { user, access: authenticatedUser.access_token },
      };
    })
    .catch((error) => error);
};

export const logoutUser = async () => {
  const authenticatedUser = await userManager.getUser();
  return await axios
    .post(`${baseUrl}${URL_AUTHENTICATION_LOGOUT}`, null, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Accept-Language": "en-US",
        Authorization: `Bearer ${authenticatedUser?.access_token}`,
      },
      withCredentials: true,
      timeout: HTTP_TIMEOUT,
    })
    .then((response) => response)
    .catch((error) => error);
};

export default function* rootSaga() {
    yield all([]);
}
